import classNames from 'classnames'

import './Label.scss'

interface LabelProps {
  children: React.ReactNode
  htmlFor?: string
  small?: boolean
  position?: 'top' | 'bottom' | 'right' | 'left'
  uppercase?: boolean
  hidden?: boolean
}

function Label({
  children,
  htmlFor,
  small,
  position = 'top',
  uppercase,
  hidden
}: LabelProps) {
  if (htmlFor) {
    return (
      <label
        className={
          classNames(
            'label',
            { small },
            { [`${position}`]: position },
            { uppercase },
            { hidden }
          )
        }
        htmlFor={htmlFor}
        aria-hidden={hidden}
      >
        {children}
      </label>
    )
  }
  return (
    <span
      className={
        classNames(
          'label',
          { small },
          { [`${position}`]: position },
          { uppercase }
        )
      }
    >
      {children}
    </span>
  )
}

export default Label
